import { Box, Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { BsBarChart } from 'react-icons/bs'

const ChartSkeleton = ({ title }) => {
    return (
        <Box bg={"#fbf9fa"} border={"3px"} borderStyle={"dashed"} borderColor={"#ebe6e7"} p="16">
            <Flex justifyContent={"center"} alignItems={"center"} direction={"column"}>
                <BsBarChart color='#d1d5dc' fontSize={"20px"} />
                <Text color='#d1d5dc' fontSize={"sm"} fontWeight={"semibold"}>{title}</Text>
                <Text fontSize={"xs"} color={"#6a7282"} fontWeight={"hairline"}>Start sending messages to see analytics</Text>
            </Flex>
        </Box>
    )
}

export default ChartSkeleton